import TopNavResponsive from '../ui/TopNavResponsive';
import {Link, NavLink} from 'react-router-dom';
import Flex from '../ui/Flex';
import {Dropdown, DropdownButton, DropdownContent} from '../ui/DropDown';
import {Drawer, DrawerContent, DrawerDropdown, DrawerItem} from '../ui/Drawer';
import { useMemo, useState} from 'react';
import {selectAllCart} from '../../features/cart/cartSlice';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {selectCurrentUser} from '../../features/user/userSlice';

const SearchBar = styled.input`
  width: 60%;
  margin-left: 1em;
`

export default function CustomerNav() {
  const user = useSelector(selectCurrentUser)
  const cart = useSelector(selectAllCart)
  const cartSize = useMemo(() => calcCartSize(cart), [cart])
  const [drawerClosing, setDrawerClosing] = useState(false);
  const [drawerOpen, setDrawer] = useState(false);
  const toggleDrawer = () => { setDrawer(!drawerOpen) };


  function calcCartSize(cart) {
    let size = 0
    console.log(cart)
    if(cart !== undefined && cart !== null) {
      for(const product of cart) {
        // Assume an amount of zero if a cart quantity is blank
        if(product.amount !== '') {
          size += parseInt(product.amount)
        }
      }
    }
    return size
  }

  const callback = () => e => {
    if(e.animationName === 'SlideOut') {
      setDrawer(false);
      setDrawerClosing(false);
    }
  }

  return (
    <>
      <TopNavResponsive>
        <div className='show'>
          <button onClick={toggleDrawer} className="icon">☰</button>
          <Link className='logo' to='/'>The Wandering Eye</Link>
        </div>

        <Flex style={{height: '100%'}} className='show' flexDirection='row' justifyContent='center' alignContent='center' flex='auto'>
          <SearchBar
            type='text'
            placeholder='Search...'
          />
          <button><span  className="material-icons">search</span></button>
        </Flex>

        <div className='hide'>
          { user ?
            <Dropdown>
              <DropdownButton>My Account</DropdownButton>
              <DropdownContent>
                <Link to='/orders'>Orders</Link>
                <Link to="/profile">Profile</Link>
                <hr/>
                <Link to='/signout'>Sign Out</Link>
              </DropdownContent>
            </Dropdown>
            :
            <NavLink to="/signin">Login</NavLink>
          }
          <NavLink className='cart' to='/cart'>
            <Flex alignItems='center'>
              {`${cartSize} `}{` `}
              <span style={{fontSize: '1em', marginLeft: '1em', padding: 0}} className="material-icons cart">shopping_cart </span>
            </Flex>
          </NavLink>

        </div>
      </TopNavResponsive>
      <Drawer onClick={() => setDrawerClosing(true)} open={drawerOpen} closing={drawerClosing}>
        <DrawerContent onClick={() => setDrawerClosing(true)}
                       className = {`${drawerClosing ? 'ClosedDrawer' : 'OpenDrawer'}`}
                       onAnimationEnd={callback()}>
          <div className='SideNav-header'>
            <div className='SideNav-Header-item'><NavLink to='/'>The Wandering Eye</NavLink></div>
          </div>
          <DrawerItem to="/profile">Profile</DrawerItem>
          <DrawerItem to='/signout'>Sign Out</DrawerItem>
          <DrawerDropdown>
            Login
            <DropdownContent>
              <NavLink to="/login">Customer Login</NavLink>
              <NavLink to="/employee">Employee Login</NavLink>
            </DropdownContent>
          </DrawerDropdown>
        </DrawerContent>
      </Drawer>
    </>
  )
}